import { FunctionsHttpError } from '@supabase/supabase-js';

type EdgeFunctionErrorDetails = { status: number; code: string | null };

// The envelope rides on `details` because handleDatabaseOperation keeps only
// an error's message and details when it wraps it in an ErrorHandlingResult.
export async function resolveFunctionsHttpError(error: Error): Promise<Error> {
  if (!(error instanceof FunctionsHttpError)) return error;
  const context: unknown = error.context;
  if (!(context instanceof Response)) return error;
  const payload = (await context.json().catch(() => null)) as {
    error?: unknown;
    errorCode?: unknown;
    code?: unknown;
  } | null;
  const message =
    typeof payload?.error === 'string' && payload.error
      ? payload.error
      : `Edge Function returned ${context.status}`;
  const errorCode =
    typeof payload?.errorCode === 'string' ? payload.errorCode : null;
  const details: EdgeFunctionErrorDetails = {
    status: context.status,
    code: typeof payload?.code === 'string' ? payload.code : null,
  };
  return Object.assign(
    new Error(errorCode ? `${message} [${errorCode}]` : message),
    { details }
  );
}

export function isApplyInProgressError(error: unknown): boolean {
  const details = (error as { details?: { code?: unknown } } | null)?.details;
  return details?.code === 'apply_in_progress';
}
